import { observable, action, runInAction } from 'mobx';
import userEmailManagementAPI from '../apis/userEmailManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class UserEmailManagementStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = 10;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*SearchResult start*/
  @observable searchItem = {
    "email": ''
  }
  @observable emailList = []
  @observable showEmailList = []
  @action
  async onSearchEmailAction(params) {
    this.isFetching = true;
    this.emailList = [];
    this.pageNo = 1;
    this.pageSize = 10;
    try {
      const response = await userEmailManagementAPI.searchAction(params);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.emailList = response.data.data?.list || []
          this.showEmailList = response.data.data?.list.slice(0,this.pageSize)
          this.itemCount = response.data.data?.list.length
          this.searchItem = params;
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/

  /*add */
  @action
  async onAddEmailAction(params){
    this.isFetching = true
    try {
      const response = await userEmailManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchEmailAction(this.searchItem)
        }else {
          alertMessage.error('Add Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }

  /*delete*/
  @action
  async onDeleteEmailAction(id) {
    this.isFetching = true
    try {
      const response = await userEmailManagementAPI.deleteAction(id);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchEmailAction(this.searchItem)
        }else {
          alertMessage.error('Delete Failed！' + response.data.messageEn +'')
        }
      });
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }

  /*enable permission*/
  @action
  async onEnableAction(){
    this.isFetching = true
    try {
      const response = await userEmailManagementAPI.enableAction()
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Enable Success！')
          this.onSearchEmailAction(this.searchItem)
        }else {
          alertMessage.error('Enable Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }

  /*disable permission*/
  @action
  async onDisableAction(){
    this.isFetching = true
    try {
      const response = await userEmailManagementAPI.disableAction()
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Disable Success！')
          this.onSearchEmailAction(this.searchItem)
        }else {
          alertMessage.error('Disable Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }

  @observable selectedRowKeys=[]
  @observable selectedRows=[]
  @action
  onChangeSelectedRowKeys(selectedRowKeys,selectedRows){
    this.selectedRowKeys=selectedRowKeys
    this.selectedRows=selectedRows
  }
  @action
  onChangePageNo(pageNo,pageSize) {
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.showEmailList = this.emailList.slice((pageNo-1)*pageSize,pageNo*pageSize)
  }
}
